"use client"; // Error boundaries must be Client Components

import { logger } from "@/utils/logger";
import { useEffect } from "react";

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
	useEffect(() => {
		// Log the error to an error reporting service
		logger.error(error);
	}, [error]);

	return (
		<div className="top-10">
			<h2>Something went wrong!</h2>
			<button
				type="button"
				onClick={
					// Attempt to recover by trying to re-render the segment
					() => reset()
				}
			>
				Try again
			</button>
		</div>
	);
}
